import { queryClient } from 'api/services/queryClient';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateCreditInvoiceArg, UpdateCreditInvoiceResponse } from 'lib/services';
import { type UseMutationResult, useMutation } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useUpdateCreditInvoice = (): UseMutationResult<
  UpdateCreditInvoiceResponse,
  unknown,
  UpdateCreditInvoiceArg
> => {
  const notify = useAppNotifications();
  const { creditInvoicesApiClient } = useServices();

  return useMutation((arg: UpdateCreditInvoiceArg) => creditInvoicesApiClient.update(arg), {
    mutationKey: MUTATION_KEYS.creditInvoices.updateOne(),
    onError: error => {
      notify.error({
        message: 'There was an error while updating credit invoice',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      notify.success({
        message: `Credit invoice updated`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.creditInvoices.all());
    },
  });
};
